import { Component, Input } from '@angular/core';
import { WalletService } from '@teem/services/wallet.service';
import Swal from 'sweetalert2';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { TopupService } from './topup.service';
import { LoaderService } from '@teem/services/loader.service';
@Component({
	selector: 'app-topup',
	templateUrl: './topup.component.html',
	styleUrls: ['./topup.component.scss']
})
export class TopupComponent {
	@Input() walletStatus: string = 'old';
	@Input() savedCards: any[] = []; // Ensure correct type

	isVisible: boolean = false;
	activeAmount: number | null = null; // Predefined amount
	customAmount: number | null = null; // User-defined custom amount
	amounts = [25, 50, 100, 150, 300]; // Numeric predefined amounts for easier validation
	isChecked: boolean = false; // Default checked
	activeCard: number | null = null; // Initially, no card is active



	constructor(
		private walletService: WalletService,
		private router: Router,
		private popupService: TopupService,
		private loaderService: LoaderService
	) {
		this.popupService.topupState$.subscribe((state) => {
			if (this.walletStatus == 'new') {
				this.amounts = [100];
			}
			this.isVisible = state;
		});
	}

	open() {
		if (this.walletStatus == 'new') {
			this.amounts = [100];
		}
		this.isVisible = true;
	}

	closePopup() {
		this.isVisible = false;
	}

	// Set a predefined amount as active
	setActive(amount: number) {
		this.activeAmount = amount;
		this.customAmount = null; // Reset custom amount when selecting a predefined value
	}

	// Set a card as active
	setCardActive(cardIndex: number) {
		this.activeCard = this.activeCard === cardIndex ? null : cardIndex; // Toggle active state
		console.log(this.savedCards[this.activeCard].card_id);
	}

	toggleCheckbox(): void {
		this.isChecked = !this.isChecked;
	}

	// Submit form
	onSubmit(form: NgForm): void {
		let amount: number | null = this.activeAmount ?? this.customAmount;
		let save: boolean | false = this.isChecked;
		let transactionId: any | null = this.savedCards[this.activeCard]?.id;

		if (!amount || amount < 25) {
			Swal.fire('Error', 'Please enter a valid amount (minimum 25 SAR).', 'error');
			return;
		}

		this.loaderService.startLoading();
		const payload = { amount, save, transactionId };
		this.walletService.topup(payload).subscribe({
			next: (data: any) => {
				// Success logic
				window.location.href = data.url;
				// this.router.navigateByUrl(data.url);
			},
			error: (err) => {
				// Error handling
				this.loaderService.stopLoading();
				Swal.fire('Error', 'Failed to top-up. Please try again later.', 'error');
			}
		});
	}
}
